var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/**
 * Helper function to create a Matrix room suitable for use with MatrixProvider.
 * Access can currently be set to "public-read-write" | "public-read"
 */
export function createMatrixRoom(matrixClient, roomName, access) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const initial_state = [];
            // guests should not be able to actually join the room,
            // because we don't want guests to be able to write
            initial_state.push({
                type: "m.room.guest_access",
                state_key: "",
                content: {
                    guest_access: "forbidden",
                },
            });
            // if there is no public write access, make sure to set
            // join_rule to invite
            initial_state.push({
                type: "m.room.join_rules",
                content: {
                    join_rule: access === "public-read-write" ? "public" : "invite",
                },
            });
            // The history of a (publicly accessible) room should be readable by everyone,
            // so that all users can get all yjs updates
            initial_state.push({
                type: "m.room.history_visibility",
                content: {
                    history_visibility: "world_readable",
                },
            });
            // for e2ee
            // initial_state.push({
            //   type: "m.room.encryption",
            //   state_key: "",
            //   content: {
            //     algorithm: "m.megolm.v1.aes-sha2",
            //   },
            // });
            const ret = yield matrixClient.createRoom({
                room_alias_name: roomName,
                visibility: "public",
                name: roomName,
                topic: "",
                initial_state,
            });
            // TODO: add room to space
            return { status: "ok", roomId: ret.room_id };
        }
        catch (e) {
            if (e.errcode === "M_ROOM_IN_USE") {
                return "already-exists";
            }
            if (e.name === "ConnectionError") {
                return "offline";
            }
            return {
                status: "error",
                error: e,
            };
            // offline error?
        }
    });
}
//# sourceMappingURL=createMatrixRoom.js.map